export default __webpack_public_path__ + "static/media/webbing4.c3469152.png";